/** Scrivener-style corkboard scope + light grid snap. */

export const CORK_COLS = 60;
export const CORK_ROW_H = 10;
export const CORK_DEFAULT_W = 10;
export const CORK_DEFAULT_H = 15;
export const CORK_MAX_W = 20;
export const CORK_MAX_H = 30;
/** Slight snap — positions land on even grid cells. */
export const CORK_SNAP = 2;

export function notebookScopeKey(notebookId) {
  return `nb:${notebookId}`;
}

export function folderScopeKey(folderId) {
  return `folder:${folderId}`;
}

export function snapCoord(n, snap = CORK_SNAP) {
  if (!Number.isFinite(n)) return 0;
  return Math.round(n / snap) * snap;
}

export function snapLayoutItem(item, snap = CORK_SNAP) {
  if (!item || item.i == null) return item;
  const w = Math.max(snap, snapCoord(item.w ?? CORK_DEFAULT_W, snap));
  const h = Math.max(snap, snapCoord(item.h ?? CORK_DEFAULT_H, snap));
  return {
    i: String(item.i),
    x: Math.max(0, snapCoord(item.x ?? 0, snap)),
    y: Math.max(0, snapCoord(item.y ?? 0, snap)),
    w: Math.min(CORK_MAX_W, w),
    h: Math.min(CORK_MAX_H, h),
  };
}

export function snapLayout(layout, snap = CORK_SNAP) {
  if (!Array.isArray(layout)) return [];
  return layout.map((item) => snapLayoutItem(item, snap)).filter(Boolean);
}

/** Pack unscoped cards left→right without overlap. */
export function packMissingCards(existingLayout, textIds, w = CORK_DEFAULT_W, h = CORK_DEFAULT_H, cols = CORK_COLS) {
  const layout = [...(existingLayout || [])];
  const have = new Set(layout.map((l) => l.i));
  const overlaps = (x, y) =>
    layout.some((l) => l.x < x + w && l.x + l.w > x && l.y < y + h && l.y + l.h > y);

  for (const id of textIds) {
    if (have.has(id)) continue;
    let x = 0;
    let y = 0;
    let placed = false;
    let guard = 0;
    while (!placed && guard++ < 5000) {
      if (!overlaps(x, y)) {
        layout.push({ i: id, x, y, w, h });
        have.add(id);
        placed = true;
      } else {
        x += w;
        if (x + w > cols) {
          x = 0;
          y += h;
        }
      }
    }
  }
  return layout;
}

/** Immediate children of a corkboard container (notebook root or folder). */
export function textsInScope(notebookTexts, folderId) {
  const list = notebookTexts || [];
  if (!folderId) return list.filter((t) => !t.parentId);
  return list.filter((t) => t.parentId === folderId);
}
